
export interface IDropdownValue {
    keys: string[];
    asKeyword: boolean;
}

export interface FilterFields {
    keywords: string[];
    dropdowns?: Record<string, IDropdownValue>
}

export const isFilterApplied = (filters?: FilterFields) => {
    if (!filters) {
        return false;
    }

    if (filters.keywords.length) {
        return true;
    }

    if (!filters.dropdowns) {
        return false;
    }

    if (Object.values(filters.dropdowns).some(filter => filter.keys.length)) {
        return true;
    }

    return false;
};
